/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const bookmark = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.057 14.913 8 12.073l-4.057 2.84a.481.481 0 0 1-.757-.394V1.963c0-.532.43-.963.962-.963h7.704c.531 0 .962.431.962.963v12.556a.481.481 0 0 1-.757.394Z"
      clipRule="evenodd"
    />
  </svg>
)
export default bookmark
